/**
 * Утилиты для работы с аутентификацией
 */

// Ключи для хранения токенов в localStorage
const TOKEN_KEY = 'auth_token';
const REFRESH_TOKEN_KEY = 'refresh_token';
const USER_KEY = 'user_data';

// Сохранение токена доступа
export const setToken = (token: string): void => {
  localStorage.setItem(TOKEN_KEY, token);
};

// Получение токена доступа
export const getToken = (): string | null => {
  return localStorage.getItem(TOKEN_KEY);
};

// Сохранение refresh-токена
export const setRefreshToken = (token: string): void => {
  localStorage.setItem(REFRESH_TOKEN_KEY, token);
};

// Получение refresh-токена
export const getRefreshToken = (): string | null => {
  return localStorage.getItem(REFRESH_TOKEN_KEY);
};

// Проверка аутентификации
export const isAuthenticated = (): boolean => {
  return !!getToken();
};

// Очистка данных аутентификации
export const clearAuth = (): void => {
  localStorage.removeItem(TOKEN_KEY);
  localStorage.removeItem(REFRESH_TOKEN_KEY);
  localStorage.removeItem(USER_KEY);
};

// Сохранение данных пользователя
export const setUser = (user: any): void => {
  localStorage.setItem(USER_KEY, JSON.stringify(user));
};

// Получение данных пользователя
export const getUser = (): any | null => {
  const user = localStorage.getItem(USER_KEY);
  return user ? JSON.parse(user) : null;
};

// Проверка роли пользователя
export const hasRole = (role: string): boolean => {
  const user = getUser();
  return user?.role === role;
};

export default {
  setToken,
  getToken,
  setRefreshToken,
  getRefreshToken,
  isAuthenticated,
  clearAuth,
  setUser,
  getUser,
  hasRole,
};
